module.exports = __webpack_public_path__ + "img/tag_ended.c6252776.png";